import { Button, Grid } from '@mui/material'
import React from 'react'
import TextField from '@mui/material/TextField';
import { useState } from 'react';
// import { useLocation } from 'react-router';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import SnackBar from '../General/SnackBar';
import { PostCspMappingRequest } from 'API/DS_Wallet/api';
import { useNavigate } from 'react-router';


const CspMapping = () => {
  // const location=useLocation()
  // console.log("location",location);

  const [PostData, setPosData] = useState("")
  const[isLoading,setIsLoading]=useState(false)
  const[openAlert,setOpenAlert]=useState(false)
  const[AlertType,setAlertType]=useState("success")
  const[AlertMessage,setAlertMessage]=useState("")
  const Nav=useNavigate()


  const handleChange = (value) => {
    if (/^\d*$/.test(value)) {
      setPosData(value);
    }
  };

  const handleAlertClose=()=>{
    setOpenAlert(false)
  }

  const handleAlertOpen=(message,type)=>{
    setAlertType(type)
    setAlertMessage(message)
    setOpenAlert(true)
  }

  const handleSubmit=()=>{
    if(PostData&&PostData!==""){
      PostCspMappingRequest(PostData,setIsLoading,handleAlertOpen,Nav)
    }
    else{
      handleAlertOpen("Please enter number of CSPs", "error")
    }
  }

 


  return (
    <Grid container mt={1}>
      <SnackBar open={openAlert} handleClose={handleAlertClose} message={AlertMessage} type={AlertType}  />
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      
      <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
        <TextField
          id="outlined-basic"
          value={PostData}
          label="Number of CSP"
          variant="outlined"
          fullWidth
          onChange={(e) => handleChange(e.target.value)}
        />
      </Grid>
      <Grid container justifyContent='center' mt={5}>
        <Grid item xl={2} lg={2} md={4} sm={12} xs={12} >
          <Button fullWidth variant='contained' color='secondary' onClick={()=>handleSubmit()}>Forward request to SH</Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CspMapping